import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import api from '@/services/api.js'
import surveyApi from '@/services/survey.js'
import vSelect from "vue-select";

import './assets/scss/custom.scss'
import "vue-select/dist/vue-select.css";

import VueEllipseProgress from 'vue-ellipse-progress';
Vue.use(VueEllipseProgress);
// Vue.use(VueEllipseProgress, "vep"); you can define a name and use the plugin like <vep/>

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(VueAxios, axios)

Vue.component("v-select", vSelect);


Vue.config.productionTip = false

const access_token = store.getters.getToken()
if (access_token) {
  api.defaults.headers.common['Authorization'] = access_token
  surveyApi.defaults.headers.common['Authorization'] = access_token
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
